export default "__VITE_ASSET__d1ad0969__"